// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Field } from 'redux-form';
import get from 'lodash/get';
import { Element } from 'react-scroll';
// Components
import OMTabs from '../OMTabs/OMTabs';
import OMTab from '../OMTabs/OMTab';
import OMTextArea from '../OMTextArea/OMTextArea';
// Helpers
import { language } from '../../../constants';
// Styles`
import * as styles from './OMTextFieldWithOptionsLang.scss';


class OMTextFieldWithOptionsLang extends Component {
  state = {
    activeLang: this.props.isForeign ? language.fallback : language.default
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.isForeign !== this.props.isForeign) {
      this.setState({ activeLang: nextProps.isForeign ? language.fallback : language.default });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const isLocaleChanged = (nextProps.locale !== this.props.locale);
    const isActiveLangChanged = (nextState.activeLang !== this.state.activeLang);
    const isDisabledStateChanged = (nextProps.isOptionalLangsDisabled !== this.props.isOptionalLangsDisabled);
    const isFields = (nextProps.fields !== this.props.fields);
    const isNameStateChanged = (nextProps.name !== this.props.name);
    const isForeignChanged = nextProps.isForeign !== this.props.isForeign;

    return (
      isLocaleChanged
      || isActiveLangChanged
      || isDisabledStateChanged
      || isFields
      || isNameStateChanged
      || isForeignChanged
    );
  }

  handleSwitchLang = (key) => this.setState({ activeLang: key });

  renderTextArea = (fieldProps) => {
    const { input, isHebrew, label, meta: { touched, error, active } } = fieldProps;

    return (
      <Element name={input.name} className={styles.formField}>
        <OMTextArea
          className={cx({ 'has-error': error && !active && touched, touched }, { [styles.hebrew]: isHebrew }, this.props.className)}
          {...input}
          maxLength={this.props.maxLength || ''}
          placeholder={label}
          isInput={this.props.isInput}
        />
        {touched &&
        (error && <span className={styles.required}>{this.props.translate('errorFieldMessages', 'required')}</span>)}
      </Element>
    );
  };

  renderField = (lang) => {
    const isHebrew = (lang === language.default);
    const { placeholderInput, name, translate } = this.props;

    return (
      <Field
        key={`${lang}_${name}`}
        name={`${name}.${lang}`}
        component={this.renderTextArea}
        label={placeholderInput ?
          placeholderInput('langs', 'placeholder', lang)
          : translate('langs', 'placeholder', lang)
        }
        isHebrew={isHebrew}
      />
    );
  };

  renderTab = (lang) => (
    <OMTab
      key={`${this.props.name}_${lang}`}
      id={lang}
      title={this.props.translate('langs', lang)}
      isDisabled={this.props.isOptionalLangsDisabled &&
        (lang !== (this.props.isForeign ? language.fallback : language.default))}
    >
      {this.renderField(lang)}
    </OMTab>
  );

  render() {
    const { fields, maxLength, isForeign } = this.props;
    const { activeLang } = this.state;
    const supportedLanguages = get(language, `${isForeign ? 'supportedForeignLanguages' : 'supportedLanguages'}`, []);

    return (
      <div className={cx(styles.item, 'text-field-with-optional-langs')}>
        <OMTabs
          defaultActiveTabKey={this.state.activeLang}
          onSelect={this.handleSwitchLang}
          className={cx(this.props.classNameTabs, 'optional-langs-tabs')}
        >
          {supportedLanguages.map(this.renderTab)}
        </OMTabs>
        {maxLength &&
          <div className={styles.maxLength}>
            <p>
              {(fields && fields[activeLang]) ? fields[activeLang].length : 0} / {maxLength}
            </p>
          </div>
        }
      </div>
    );
  }
}

OMTextFieldWithOptionsLang.propTypes = {
  translate: PropTypes.func,
  name: PropTypes.string,
  placeholder: PropTypes.object,
  isInput: PropTypes.bool,
  isOptionalLangsDisabled: PropTypes.bool,
  classNameTabs: PropTypes.string,
  className: PropTypes.string,
  locale: PropTypes.string,
  placeholderInput: PropTypes.string,
  fields: PropTypes.object,
  maxLength: PropTypes.string,
  isForeign: PropTypes.bool
};

export default OMTextFieldWithOptionsLang;
